import { Stack, Title, Text } from "@mantine/core"
import { LabelWithTooltip, Select } from "@tfg/ui"
import _ from "lodash"
import { useTranslation } from "react-i18next"

import type {
  ContentFilteringProps,
  EcoScoreDisplayMode,
} from "@tfg/types/types/communication-studio/configurations.types"
import {
  DEFAULT_ECOSCORE_DISPLAY_MODE,
  ECOSCORE_DISPLAY_MODES,
} from "@tfg/types/types/communication-studio/configurations.types"

function isEcoScoreDisplayMode(value: string): value is EcoScoreDisplayMode {
  return (ECOSCORE_DISPLAY_MODES as readonly string[]).includes(value)
}

type EcoScoreDisplayModeRendererProps = {
  ecoScoreDisplayMode?: EcoScoreDisplayMode | null
  updateModalConfigurations: (
    configurations: Partial<ContentFilteringProps> | null
  ) => void
}

export const EcoScoreDisplayModeRenderer = ({
  ecoScoreDisplayMode,
  updateModalConfigurations,
}: EcoScoreDisplayModeRendererProps) => {
  const { t } = useTranslation("communicationStudio")

  const handleEcoScoreDisplayModeChange = (value: string | null) => {
    if (!value || !isEcoScoreDisplayMode(value)) {
      return
    }

    updateModalConfigurations({
      ecoScoreDisplayMode: value,
    })
  }

  return (
    <Stack gap="xs">
      <Stack gap={2}>
        <Title order={4} fw={500}>
          {t("tabs.content.contentFiltering.ecoScoreDisplayMode.title")}
        </Title>
        <Text>
          {t("tabs.content.contentFiltering.ecoScoreDisplayMode.subtitle")}
        </Text>
      </Stack>
      <Select
        label={
          <LabelWithTooltip
            withAsterisk
            label={t("tabs.content.contentFiltering.ecoScoreDisplayMode.label")}
            hoverHelperText={t(
              "tabs.content.contentFiltering.ecoScoreDisplayMode.tooltip"
            )}
          />
        }
        data={ECOSCORE_DISPLAY_MODES.map((mode) => ({
          label: _.toUpper(mode),
          value: mode,
        }))}
        value={ecoScoreDisplayMode ?? DEFAULT_ECOSCORE_DISPLAY_MODE}
        onChange={handleEcoScoreDisplayModeChange}
        placeholder={t(
          "tabs.content.contentFiltering.ecoScoreDisplayMode.placeholder"
        )}
      />
    </Stack>
  )
}
